// extracted by mini-css-extract-plugin
export default {"btnMore":"MoreItems_btnMore__r1zn8"};